<template>
  <div class="page-class page-transfer-list">
    <h1 class="page-title">{{ title }}</h1>
    <table-box
      :columns="columns"
      :rows="transfers"
      :pagination="pagination"
      :baseUrl="baseUrl"
      :loading="loading"
      emptyText="No transfer found. Please add new transfer."
      :showAdd="true"
      addText="Create new transfer"
      @add="onAdd"
      @edit="onEdit"
      @delete="onDelete"
    >
      <template v-slot:transferNameFormatted="slotProps">
        {{ slotProps.row.metaName }}
        <span class="span-help-text">({{ slotProps.row.metaKey }})</span>
        <br />
        <span class="span-help-text">{{ slotProps.row.metaDesc }}</span>
      </template>
    </table-box>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
import TableBox from '@/components/TableBox.vue';
import router from '@/router';

export default {
  name: 'TransferList',
  components: {
    TableBox
  },
  metaInfo() {
    return {
      title: 'Transferowerview',
      meta: [
        {
          name: 'description',
          content: 'Manage transfers'
        }
      ]
    };
  },
  mounted() {
    this.list({ query: this.$route.query });
  },
  data() {
    return {
      title: 'Buchungen',
      columns: [
        {
          type: 'row_num',
          headerText: '#',
          class: { 'text-center': true },
          textKey: 'rowNum',
          width: '5%'
        },
        {
          type: 'date',
          headerText: 'Buchungsdatum',
          textKey: 'createdAt',
          width: '30%'
        },
        {
          type: 'string',
          headerText: 'Konto Zahler',
          textKey: 'recFrm',
          width: '15%'
        },
        {
          type: 'string',
          headerText: 'Konto Empfänger',
          textKey: 'recTo',
          width: '15%'
        },
        {
          type: 'string',
          headerText: 'gebuchte Menge',
          textKey: 'amount',
          class: { 'text-center': true },
          width: '15%'
        },
        {
          type: 'string',
          headerText: 'Guthaben alt',
          textKey: 'balance',
          class: { 'text-center': true },
          width: '15%'
        }
      ]
    };
  },
  computed: {
    ...mapState('transfer', ['loading', 'baseUrl', 'transfers', 'pagination'])
  },
  methods: {
    ...mapActions('transfer', ['list', 'deleteOne']),
    onAdd() {
      router.push('/transfer/new');
    },
    onEdit({ row }) {
      router.push(`/transfer/${row.id}`);
    },
    onDelete({ row }) {
      Vue.swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this.",
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',

        preConfirm: () => {
          this.deleteOne({
            type: 'transfer',
            transferId: row.id
          });
        }
      });
    }
  }
};
</script>
